export interface ValidationCompletionResponse {
  under_review?: boolean;
  status_url?: string;
}

export interface ValidationActionCopyOptions {
  hasMissingDocuments: boolean;
  isRunning: boolean;
}

export const resolveValidationCompletionDestination = (
  response: ValidationCompletionResponse | null | undefined,
  jobId: string,
  lcNumber?: string,
): string => {
  if (response?.under_review && response.status_url) {
    return response.status_url;
  }

  const params = new URLSearchParams({
    section: "reviews",
    jobId,
  });
  if (lcNumber) {
    params.set("lc", lcNumber);
  }
  return `/lcopilot/exporter-dashboard?${params.toString()}`;
};

export const getValidationActionCopy = ({
  hasMissingDocuments,
  isRunning,
}: ValidationActionCopyOptions) => ({
  title: "Starting validation",
  description: "Applying your confirmed fields and running the validation pipeline…",
  button: isRunning
    ? "Starting…"
    : hasMissingDocuments
      ? "Start Validation Anyway"
      : "Start Validation",
});
